import styled from "styled-components";
import colorPalette from "@streeteasy/design-system/deprecated/colors";

const BoroughNeighborhoodsColumn = styled.div`
  width: 180px;
`;

const BoroughNeighborhoods = styled.div`
  border: 1px solid ${colorPalette.foxGrey};
  display: flex;
  height: 450px;
  margin-top: 10px;
  overflow: auto;
  padding: 10px;
`;

BoroughNeighborhoods.displayName = "BoroughNeighborhoods";
BoroughNeighborhoodsColumn.displayName = "BoroughNeighborhoodsColumn";

export { BoroughNeighborhoods, BoroughNeighborhoodsColumn };
